import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";

// components
import Button from "../Button/Button";

// styles
import * as styles from "./Banner.module.css";

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  onCtaClick: PropTypes.func,
  pageName: PropTypes.string,
  bannerImage: PropTypes.string,
  imageHeight: PropTypes.string,
  imageWidth: PropTypes.string,
};

const defaultProps = {
  title: "AI-powered Digital Twin™ for Metabolic Health",
  description:
    "Experience metabolic health transformation with AI Digital Twin™ technology. This program goes beyond temporary fixes to heal metabolism at its root, helping you improve metabolism, achieve sustainable diabetes remission, and naturally support PMOS improvement.",
  onCtaClick: () => {},
};

const Banner = ({
  title,
  pageName,
  description,
  ctaText,
  ctaLink,
  onCtaClick,
  bannerImage,
  imageHeight,
  imageWidth,
}) => {
  const handleCtaClick = e => {
    if (onCtaClick) {
      onCtaClick(e);
    }
  };

  return (
    <section className={styles.bannerWrapper}>
      <div className="container">
        <div className={styles.bannerContent}>
          {/* Left Content */}
          <div className={styles.bannerLeft}>
            {pageName && <h3 className={styles.bannerPageName}>{pageName}</h3>}
            <h1 className={styles.bannerTitle}>{title}</h1>
            <p className={styles.bannerDescription}>{description}</p>
            {ctaText && (
              <Button
                text={ctaText}
                href={ctaLink}
                variant="primary"
                onClick={handleCtaClick}
                btnClass={styles.bannerCta}
              />
            )}
          </div>

          {/* Right Image */}
          <div className={styles.bannerRight}>
            {bannerImage ? (
              <img
                src={bannerImage}
                alt="Twin Health Banner"
                className={styles.bannerImage}
                style={{
                  ...(imageHeight && { height: imageHeight }),
                  ...(imageWidth && { width: imageWidth }),
                }}
              />
            ) : (
              <StaticImage
                src="../../images/home/home-banner-new.png"
                alt="Twin Health Banner"
                placeholder="blurred"
                className={styles.bannerImage}
                loading="lazy"
                style={{
                  ...(imageHeight && { height: imageHeight }),
                  ...(imageWidth && { width: imageWidth }),
                }}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

Banner.propTypes = propTypes;
Banner.defaultProps = defaultProps;

export default Banner;
